import React from "react";
import styles from "../../assets/styles/_shop.module.scss";
import FadeInSection from "../common/FadeInSection";
import Breadcrumb from "../common/breadcrum";

const ShopPageComponent = () => {
  const listShop = [
    // {
    //   id: 1,
    //   name: "AINZ&TULPE",
    // },
    // {
    //   id: 2,
    //   name: "イオンリテール",
    // },
    // {
    //   id: 3,
    //   name: "ウエルシア薬局",
    // },
    // {
    //   id: 4,
    //   name: "カワチ薬品",
    // },
    // {
    //   id: 5,
    //   name: "キリン堂",
    // },
    {
      id: 6,
      name: "杏林堂薬局",
    },
    // {
    //   id: 7,
    //   name: "クスリのアオキ",
    // },
    {
      id: 8,
      name: "くすりの福太郎",
    },
    // {
    //   id: 9,
    //   name: "ゲンキー",
    // },
    // {
    //   id: 10,
    //   name: "ココカラファイン",
    // },
    // {
    //   id: 11,
    //   name: "サッポロドラッグストアー",
    // },
    // {
    //   id: 12,
    //   name: "サンドラッグ",
    // },
    // {
    //   id: 13,
    //   name: "shopin",
    // },
    {
      id: 14,
      name: "スギ薬局",
    },
    // {
    //   id: 15,
    //   name: "セキ薬品（ドラッグストアセキ）",
    // },
    // {
    //   id: 16,
    //   name: "中部薬品（Ｖドラッグ）",
    // },
    // {
    //   id: 17,
    //   name: "ツルハドラッグ",
    // },
    // {
    //   id: 18,
    //   name: "ディスカウントドラッグコスモス",
    // },
    // {
    //   id: 19,
    //   name: "トモズ",
    // },
    // {
    //   id: 20,
    //   name: "トライアル",
    // },
    {
      id: 21,
      name: "ドラッグイレブン",
    },
    // {
    //   id: 22,
    //   name: "ドラッグストアウォンツ・ウェルネス",
    // },
    // {
    //   id: 23,
    //   name: "ドラッグストア ザグザグ",
    // },
    // {
    //   id: 24,
    //   name: "ドラッグストアモリ",
    // },
    // {
    //   id: 25,
    //   name: "ドン・キホーテ",
    // },
    // {
    //   id: 26,
    //   name: "ハンズ",
    // },
    // {
    //   id: 27,
    //   name: "富士薬品",
    // },
    {
      id: 28,
      name: "PLAZA",
    },
    // {
    //   id: 29,
    //   name: "マツモトキヨシ",
    // },
    // {
    //   id: 30,
    //   name: "ミネドラッグ",
    // },
    // {
    //   id: 31,
    //   name: "ユニー",
    // },
    {
      id: 32,
      name: "ロフト",
    },
    // {
    //   id: 33,
    //   name: "レデイ薬局",
    // },
    {
      id: 34,
      name: "matsukiyo LAB",
    },
    {
      id: 35,
      name: "ドン・キホ−テ",
    },
    {
      id: 36,
      name: "アインズ＆トルペ",
    },
    {
      id: 37,
      name: "ハンズ、ハンズビー",
    },
    // {
    //   id: 38,
    //   name: "ZAG ZAG",
    // },
  ];
  const onlineShop = [
    {
      id: 1,
      name: "公式ストアで購入する",
      link: "https://shop.beaute-de-mode.jp/collections/myo2",
    },
    {
      id: 2,
      name: "Amazonで購入する",
      link: "https://www.amazon.co.jp/stores/page/DB0DCA4F-5097-4F8A-944D-15A46616BFC1",
    },
    {
      id: 3,
      name: "Rakutenで購入する",
      link: "https://item.rakuten.co.jp/joiedebeaute/c/0000000184/?l-id=shoptop_shopmenu_shopcategory_4",
    },
    {
      id: 4,
      name: "Yahoo!で購入する",
      link: "https://store.shopping.yahoo.co.jp/beautedemode/myo2a1caa5.html#sideNaviItems",
    },
    {
      id: 5,
      name: "Qoo10で購入する",
      link: "https://www.qoo10.jp/shop/beaute-de-mode?keyword=%E3%83%9E%E3%82%A4%E3%83%BB%E3%82%AA%E3%83%BC%E3%83%84%E3%83%BC&keyword_hist=&dispType=GALLERY4",
    },
  ];
  return (
    <div className={styles.shopPage}>
      <div className={styles.shopPageList}>
        <FadeInSection>
          <div className={styles.title}>SHOP</div>
        </FadeInSection>
        <FadeInSection>
          <div className={styles.list}>
            {listShop.map((item) => (
              <div className={styles.item}>
                <a role="button" target="_blank" rel="noreferrer">
                  {item.name}
                </a>
              </div>
            ))}
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className={styles.status}>
            {/* <div className={styles.item}>*五十音順　</div> */}
            <div className={styles.item}>
              *一部店舗ではお取り扱いがない場合がございます。
            </div>
            <div className={styles.item}>
              *4月以降、全国のバラエティショップやドラックストアにて順次販売拡大
            </div>
          </div>
        </FadeInSection>
      </div>
      <div className={styles.onlineShopList}>
        <div className={styles.title}>ONLINE SHOP</div>
        <div className={styles.decs}>オンラインでの購入はこちらから</div>

        <FadeInSection>
          <div className={styles.list}>
            {onlineShop.map((item) => (
              <div className={`${styles.item} `}>
                <a href={item.link} target="_blank" rel="noreferrer">
                  {item.name}
                </a>
              </div>
            ))}
          </div>
        </FadeInSection>
      </div>

      <Breadcrumb
        data={[
          {
            title: "TOP",
            link: "/",
          },
          {
            title: "SHOP",
            link: "/shop",
          },
        ]}
      />
    </div>
  );
};

export default ShopPageComponent;
